import isEmpty from 'lodash.isempty'
import getAddress from '@/modules/mixins/getAddress'
//import { mapGetters } from 'vuex';

export default {
    mixins: [getAddress],

    data() {
        return {
            internalValue: null,
            dirty: false,
        }
    },

    computed: {
        //...mapGetters([ 'currentCountry', 'currentLanguage' ]),

        addressIsComplete() {
            let completed = Boolean(
                this.value.full_address &&
                    (this.missingParts.length === 0 ||
                        (this.missingParts.length === 1 &&
                            this.missingParts.includes(this.$t('maps.house_number')) &&
                            this.value.sub_address !== undefined))
            )
            this.$store.dispatch('setAddressStatus', completed)
            return completed
        },

        missingParts() {
            let missingParts =
                !isEmpty(this.value) && this.dirty ? this.addressMissingParts(this.value) : []
            this.$store.dispatch('setMissingParts', missingParts)
            return missingParts
        },
    },

    methods: {
        placeChanged(data) {
            this.dirty = true
            this.$emit(
                'input',
                data?.place_id ? this.convertAddress(this.parseAddress(data)) : this.value
            )
        },

        clearAddress() {
            this.dirty = false
            this.$emit('input', {})
            this.$nextTick(() => this.$emit('reset'))
        },

        addressMissingParts(address) {
            const parts = []
            if (!address || !address.street || address.street === '')
                parts.push(this.$t('maps.address'))
            if (!address || !address.house_number || address.house_number === '')
                parts.push(this.$t('maps.house_number'))
            if (!address || !address.town || address.town === '') parts.push(this.$t('maps.city'))
            if (!address || !address.zip_code || address.zip_code === '')
                parts.push(this.$t('maps.zip'))
            return parts
        },

        removeCountry(addr) {
            return addr
                .replace('Magyarország', '')
                .replace('Ausztria', '')
                .replace('Ungarn', '')
                .replace('Österreich', '')
                .replace('Hungary', '')
                .replace('Austria', '')
        },
    },
}
